import { render, staticRenderFns } from "./PendingAltTable.vue?vue&type=template&id=2915db5c&"
import script from "./PendingAltTable.vue?vue&type=script&lang=js&"
export * from "./PendingAltTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports